import Vue from "vue";
import Vuex from "vuex";
import store from "./store/index";

import SiteSearchApp from "./components/SiteSearchApp.vue";
import SiteSearchField from "./components/SiteSearchField.vue";

/**
 * Set the wizard config context based on the wizardConfig Object which is set on the WizardPage.ss of the brand website
 * **/
function hydrateApp() {
  let searchOptions = window.searchOptions ? window.searchOptions : {};

  store.commit("updateField", {
    path: "searchApp.searchOptions",
    value: searchOptions,
  });
}

/**
 * Set up config
 * **/
function init() {
  hydrateApp();

  new Vue({
    el: "#site-search-app",
    data: {},
    components: {
      "site-search-app": SiteSearchApp,
      "site-search-field": SiteSearchField,
    },
    store,
    methods: {
      toggleSearch() {
        this.$store.commit("updateField", {
          path: "searchApp.headerSearchPanelOpen",
          value: !this.$store.state.searchApp.headerSearchPanelOpen,
        });
      },
    },
  });
}

/**
 * jQuery like $(document).ready() method that you can call from anywhere
 * **/
function docReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

/**
 * Document ready let's do our stuff
 * **/
docReady(function () {
  // DOM is loaded and ready for manipulation here
  init();
});
